export class NewOrderData {
}
